import React from 'react'
import PropTypes from 'prop-types'

const CLASSES = 'tw:inline-flex tw:items-center tw:gap-1 tw:border-0 tw:bg-transparent tw:p-0 '
  + 'tw:cursor-pointer tw:text-sm tw:font-medium tw:text-ds-neutral-highest'

const AddLink = ({ label, onClick }) => (
  <button type="button" className={CLASSES} onClick={onClick}>
    <i className="fas fa-plus" />
    {' '}
    {label}
  </button>
)

AddLink.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

export default AddLink
